import React from "react";
import { Helmet } from "react-helmet-async";

/** Small helper to inject JSON-LD structured data */
export default function JsonLd({ data }) {
  if (!data) return null;
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

export function orgSchema(baseUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Maxine Consulting OPC Private Limited",
    url: baseUrl,
    logo: `${baseUrl}/logo-maxine.png`,
    sameAs: [],
    contactPoint: [{ "@type": "ContactPoint", telephone: "+91-70549-86771", contactType: "sales", areaServed: ["AE", "IN", "EU"] }],
  };
}

export function productSchema(product, baseUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: product.title,
    applicationCategory: "BusinessApplication",
    description: product.tagline,
    url: `${baseUrl}/products/${product.slug}`,
    offers: {
      "@type": "Offer",
      priceCurrency: "AED",
      price: product.price_aed_monthly,
      availability: "https://schema.org/InStock",
    },
    provider: { "@type": "Organization", name: "Maxine Consulting OPC Private Limited", url: baseUrl },
  };
}

export function articleSchema(post, baseUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    description: post.excerpt,
    image: post.cover_image_url || `${baseUrl}/logo-maxine.png`,
    datePublished: post.created_at,
    author: { "@type": "Person", name: post.author || "Maxine Team" },
    publisher: { "@type": "Organization", name: "Maxine Consulting OPC Private Limited", logo: { "@type": "ImageObject", url: `${baseUrl}/logo-maxine.png` } },
    mainEntityOfPage: { "@type": "WebPage", "@id": `${baseUrl}/insights/${post.slug}` },
  };
}

export function caseSchema(item, baseUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: item.title,
    description: item.summary,
    image: item.image_url || `${baseUrl}/logo-maxine.png`,
    author: { "@type": "Organization", name: "Maxine Consulting OPC Private Limited" },
    publisher: { "@type": "Organization", name: "Maxine Consulting OPC Private Limited", logo: { "@type": "ImageObject", url: `${baseUrl}/logo-maxine.png` } },
    mainEntityOfPage: { "@type": "WebPage", "@id": `${baseUrl}/case-studies/${item.slug}` },
  };
}
